export enum SubmissionOption {
    RequesterOnly = 'REQUESTERONLY',
    Assign = 'ASSIGN',
    Invite = 'INVITE',
    Both = 'BOTH',
    AssignMulti = 'ASSIGN-MULTI',

}